import * as api from  './api'
import * as reducers from './slice-reducers'
import { BigSale, Sale } from 'src/core/models'
import { AppDispatch } from 'src/app/store'


export const getSalesList = (currency_code: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setMySalesLoading(true))
    const data: Sale[] = await api.getSaleListAPI(currency_code)
    dispatch(reducers.setMySalesLoading(false))
    dispatch(reducers.setMySalesList(data))
    dispatch(reducers.setMySalesFiltered(data))
  }catch (error){
    dispatch(reducers.setMySalesLoading(false))
    dispatch(reducers.setMySalesError(error))
  }
}

export const getSalesDetails = (saleId: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setSaleDetailsLoading(true))
    const data: BigSale = await api.getSaleDetailsAPI(saleId)
    dispatch(reducers.setSaleDetailsLoading(false))
    dispatch(reducers.setSaleDetailsData(data))
  }catch (error){
    dispatch(reducers.setSaleDetailsLoading(false))
    dispatch(reducers.setSaleDetailsError(error))
  }
}

export const sendSaleDocument = (saleId: number, file: any, key: string) => async (dispatch: any) => {
  try {
    dispatch(reducers.setSaleSendDocumentLoading(true))
    await api.sendDocumentAPI(saleId, file, key)
    dispatch(reducers.setSaleSendDocumentLoading(false))
    dispatch(reducers.setSaleSendDocumentSuccess(true))
    dispatch(getSalesDetails(saleId))
  }catch (error){
    dispatch(reducers.setSaleSendDocumentLoading(false))
    dispatch(reducers.setSaleSendDocumentSuccess(false))
    dispatch(reducers.setSaleSendDocumentError(error))
  }
}

export const deleteSaleDocument = (saleId: number, key: string) => async (dispatch: any) => {
  try {
    dispatch(reducers.setSaleDeleteDocumentLoading(true))
    await api.deleteDocumentAPI(saleId, key)
    dispatch(reducers.setSaleDeleteDocumentLoading(false))
    dispatch(reducers.setSaleDeleteDocumentSuccess(true))
    dispatch(getSalesDetails(saleId))
  }catch (error){
    dispatch(reducers.setSaleDeleteDocumentLoading(false))
    dispatch(reducers.setSaleDeleteDocumentSuccess(false))
    dispatch(reducers.setSaleDeleteDocumentError(error))
  }
}
